import * as React from 'react'
import type { SVGProps } from 'react'
const SvgApple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.843 9.352c-1.69 2.934-.615 7.387 1.254 10.087C7.031 20.789 7.976 22 9.27 22l.074-.001c.608-.025 1.047-.212 1.472-.393.477-.203.97-.413 1.744-.413.736 0 1.206.203 1.66.4.448.193.91.394 1.59.381 1.458-.027 2.353-1.335 3.143-2.488a11.03 11.03 0 0 0 1.377-2.82l.006-.018a.1637.1637 0 0 0-.1-.206c-.256-.105-2.508-1.104-2.532-3.827-.022-2.212 1.69-3.384 2.033-3.596l.016-.01a.163.163 0 0 0 .0714-.1053.165.165 0 0 0-.0254-.1247c-1.18-1.729-2.991-1.99-3.72-2.02a3.3 3.3 0 0 0-.325-.017c-.856 0-1.676.324-2.335.583-.455.18-.848.335-1.119.335-.304 0-.699-.157-1.157-.339-.611-.242-1.305-.518-2.039-.518h-.052c-1.706.026-3.32 1.002-4.209 2.549"
    />
    <path
      fill="currentColor"
      d="M16.08 2c-1.033.042-2.273.678-3.014 1.547-.63.73-1.245 1.946-1.083 3.172.01.077.072.136.15.142.07.005.14.008.211.008 1.011 0 2.101-.559 2.846-1.46.784-.95 1.18-2.17 1.06-3.263A.165.165 0 0 0 16.08 2"
    />
  </svg>
)
export default SvgApple
